import { call, put, all, takeEvery, select } from "redux-saga/effects";
import { programsActions, generalActions } from "../actions";
import api from "../services/programs.service";
import ACTIONS from "../constants";
import { programsPagination } from "../selectors/programs.selector";

function* getPrograms(state) {
  try {
    yield put(programsActions.getProgramsRequestAttempt.pending);
    const programs = yield call(api.getProgramsRequest, state.payload);
    const pagination = JSON.parse(programs.headers["x-pagination"]);
    const data = {
      data: programs.data,
      pagination: pagination,
    };
    yield put(programsActions.getProgramsRequestAttempt.success(data));
  } catch (error) {
    if (
      error.message ===
      `Cannot read properties of undefined (reading 'x-pagination')`
    ) {
      yield put(programsActions.getProgramsRequestAttempt.error(""));
    } else {
      yield put(programsActions.getProgramsRequestAttempt.error(error.message));
    }
  }
}

function* sortPrograms(state) {
  try {
    yield put(programsActions.sortProgramsRequestAttempt.pending);
    const programs = yield call(api.sortProgramsRequest, state.payload);
    const pagination = JSON.parse(programs.headers["x-pagination"]);
    const data = {
      data: programs.data,
      pagination: pagination,
    };
    yield put(programsActions.sortProgramsRequestAttempt.success(data));
  } catch (error) {
    yield put(programsActions.sortProgramsRequestAttempt.error(error));
  }
}

function* createPrograms(state) {
  try {
    yield put(programsActions.createProgramsAttempt.pending);
    yield call(api.createProgramsRequest, state.payload);
    console.log("state.payload", state.payload);
    // const paginat = yield select(programsPagination);
    const payload = {
      id: state.payload.parentId,
      parent: state.payload.parent,
      page: 1,
      size: state.payload.perPageItems,
    };
    // const payload = {id: state.payload.clientId, page: paginat.CurrentPage, size: paginat.PageSize}
    const programs = yield call(api.getProgramsRequest, payload);
    const pagination = JSON.parse(programs.headers["x-pagination"]);
    const data = {
      data: programs.data,
      pagination: pagination,
    };
    yield put(programsActions.createProgramsAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Program saved",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(
        programsActions.createProgramsAttempt.error(errorObject.data.Name[0])
      );
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(
        programsActions.createProgramsAttempt.error(errorObject.data.Name[0])
      );
    }
    if (errorObject.status === 400) {
      yield put(
        programsActions.createProgramsAttempt.error(errorObject.data.errors)
      );
    }
  }
}

function* updatePrograms(state) {
  try {
    yield put(programsActions.updateProgramsAttempt.pending);
    yield call(api.updateProgramsRequest, state.payload);
    const paginat = yield select(programsPagination);
    let programs;
    if (state.payload.type === "overview") {
      programs = yield call(api.getProgramDetailsRequest, state.payload);
      const data = {
        type: state.payload.type,
        data: programs,
      };
      yield put(programsActions.updateProgramsAttempt.success(data));
    } else {
      const payload = {
        id: state.payload.parentId,
        parent: state.payload.parent,
        page: paginat.CurrentPage,
        size: paginat.PageSize,
      };
      programs = yield call(api.getProgramsRequest, payload);
      const pagination = JSON.parse(programs.headers["x-pagination"]);
      const data = {
        data: programs.data,
        pagination: pagination,
      };
      yield put(programsActions.updateProgramsAttempt.success(data));
    }
    yield put(
      generalActions.showToast({
        title: "Program updated",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      if (typeof errorObject === "string") {
        yield put(programsActions.updateProgramsAttempt.error(errorObject));
      } else {
        yield put(
          programsActions.updateProgramsAttempt.error(errorObject.data.Name[0])
        );
      }
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(
        programsActions.updateProgramsAttempt.error(errorObject.data.Name[0])
      );
    }
    if (errorObject.status === 400) {
      yield put(
        programsActions.updateProgramsAttempt.error(errorObject.data.errors)
      );
      // yield put(programsActions.updateProgramsAttempt.error(errorObject.data.errors[0].message));
    }
  }
}

function* deletePrograms(state) {
  try {
    yield put(programsActions.deleteProgramsAttempt.pending);
    yield call(api.deleteProgramsRequest, state.payload.id);
    const paginat = yield select(programsPagination);
    const payload = {
      id: state.payload.parentId,
      parent: state.payload.parent,
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    };
    const programs = yield call(api.getProgramsRequest, payload);
    const pagination = JSON.parse(programs.headers["x-pagination"]);
    const data = {
      data: programs.data,
      pagination: pagination,
    };
    yield put(programsActions.deleteProgramsAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Program deleted successfully",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(programsActions.deleteProgramsAttempt.error(error));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(programsActions.deleteProgramsAttempt.error(error));
    }
    if (errorObject.status === 400) {
      yield put(programsActions.deleteProgramsAttempt.error(error));
      yield put(
        generalActions.showToast({
          title: `${error}`,
          type: "Error",
        })
      );
    }
  }
}

function* getProgramDetails(state) {
  try {
    yield put(programsActions.getProgramDetailsAttempt.pending);
    const programs = yield call(api.getProgramDetailsRequest, state.payload);
    yield put(programsActions.getProgramDetailsAttempt.success(programs));
  } catch (error) {
    yield put(programsActions.getProgramDetailsAttempt.error(error));
  }
}

// program budget summary
function* getProgramBudgetSummary(state) {
  try {
    yield put(programsActions.getProgramBudgetSummaryAttempt.pending);
    const budgetSummary = yield call( api.getProgramBudgetSummaryRequest, state.payload);
    yield put(programsActions.getProgramBudgetSummaryAttempt.success(budgetSummary));
  } catch (error) {
    yield put(programsActions.getProgramBudgetSummaryAttempt.error(error.message));
  }
}
// program progress summary
function* getProgramProgressSummary(state) {
  try {
    yield put(programsActions.getProgramProgressSummaryAttempt.pending);
    const progressSummary = yield call( api.getProgramProgressSummaryRequest, state.payload);
    yield put(programsActions.getProgramProgressSummaryAttempt.success(progressSummary));
  } catch (error) {
    yield put(programsActions.getProgramProgressSummaryAttempt.error(error.message));
  }
}

function* updateProgramFlag(state) {
  try {
    yield put(programsActions.updateProgramFlagAttempt.pending);
    yield call(api.updateProgramFlagRequest, state.payload);
    yield put(programsActions.updateProgramFlagAttempt.success());
    yield put(
      generalActions.showToast({
        title: "Program flag updated successfully",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(programsActions.updateProgramFlagAttempt.error(error));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(programsActions.updateProgramFlagAttempt.error(error));
    }
    if (errorObject.status === 400) {
      yield put(programsActions.updateProgramFlagAttempt.error(error));
      yield put(
        generalActions.showToast({
          title: `${error}`,
          type: "Error",
        })
      );
    }
  }
}

/////////////////// Health Status /////////////////////////////

function* getProgressTracker(state) {
  try {
    yield put(programsActions.getProgressTrackerAttempt.pending);
    const progressTracker = yield call(api.getProgressTracker, state.payload);
    yield put(programsActions.getProgressTrackerAttempt.success(progressTracker));
  } catch (error) {
    yield put(programsActions.getProgressTrackerAttempt.error(error.message));
  }
}

function* progressTrackerFilter(state) {
  try {
    yield put(programsActions.filterProgressTrackerAttempt.pending);
    const res = yield call(api.filterProgressTracker, state.payload);
    yield put(programsActions.filterProgressTrackerAttempt.success(res));
  } catch (error) {
    yield put(programsActions.filterProgressTrackerAttempt.error(error.message));
  }
}


function* updateProgressKPI(state) {
  try {
    yield put(programsActions.updateProgressKPIAttempt.pending);
    yield call(api.updateProgressKPI, state.payload);
    yield put(programsActions.updateProgressKPIAttempt.success());
  } catch (error) {
    yield put(programsActions.updateProgressKPIAttempt.error(error.message));
  }
}

function* statusReport(state) {
  try {
    yield put(programsActions.ProgramStatusReportRequestAttempt.pending);
    const res = yield call(api.getStatusReport, state.payload);
    yield put(programsActions.ProgramStatusReportRequestAttempt.success(res));
  } catch (error) {
    yield put(programsActions.ProgramStatusReportRequestAttempt.error(error.message));
  }
}

export default function* rootSaga() {
  yield all([takeEvery(ACTIONS.PROGRAMS_CALL, getPrograms)]);
  yield all([takeEvery(ACTIONS.SORT_PROGRAMS_CALL, sortPrograms)]);
  yield all([takeEvery(ACTIONS.CREATE_PROGRAMS_CALL, createPrograms)]);
  yield all([takeEvery(ACTIONS.UPDATE_PROGRAMS_CALL, updatePrograms)]);
  yield all([takeEvery(ACTIONS.DELETE_PROGRAMS_CALL, deletePrograms)]);
  yield all([takeEvery(ACTIONS.GET_PROGRAM_DETAILS_CALL, getProgramDetails)]);
  yield all([takeEvery(ACTIONS.PROGRAM_FLAG_CALL, updateProgramFlag)]);
  yield all([takeEvery(ACTIONS.PROGRESS_TRACKER_FILTER_CALL, progressTrackerFilter)]);
  yield all([takeEvery(ACTIONS.PROGRESS_TRACKER_CALL, getProgressTracker)]);
  yield all([takeEvery(ACTIONS.UPDATE_PROGRESS_KPI_CALL, updateProgressKPI)]);
  yield all([takeEvery(ACTIONS.PROGRAM_STATUS_REPORT_CALL, statusReport)]);
  yield all([takeEvery(ACTIONS.GET_PROGRAM_BUDGET_SUMMARY_CALL, getProgramBudgetSummary)]);
  yield all([takeEvery(ACTIONS.GET_PROGRAM_PROGRESS_SUMMARY_CALL, getProgramProgressSummary)]);
}
